import { buildRoutes } from '@/modules/common/route/utils';

export const indexRouteNameSuffix = 'index';

// TODO: Rename to routeNameCampaign
const campaignRouteName = 'campaigns-poc';

export const campaignSubRouteNames = {
  list: 'list',
  summary: 'summary',
  targetGroup: 'target-group',
  creativeGroup: 'creative-group',
  adGroup: 'ad-group',
} as const satisfies Record<string, string>;

export const campaignRouteParams = {
  targetGroupId: 'targetId',
  campaignGroupId: 'campaignId',
  adGroupId: 'adGroupId',
};

export const campaignRoutes = buildRoutes({
  baseName: campaignRouteName,
  indexName: indexRouteNameSuffix,
  subRouteNames: campaignSubRouteNames,
});
